var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1921 495.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#231f20;stroke-miterlimit:10;opacity:0.69;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,271,167.12,26.59q34.4,57.29,68.77,114.58a117.87,117.87,0,0,0,119.43-1.3l84.38,97.24c22.17-1.41,46.06-3.81,71.4-7.63a833.73,833.73,0,0,0,83.08-16.89C635.52,274.6,680,311.76,711,333.37c51.6,35.95,99.42,52.12,191.85,82.65,56.29,18.59,104,31.23,137.87,39.43a827.65,827.65,0,0,1,321.94-163.64,277.86,277.86,0,0,1,81.78,32.47L1577,181.68l73.86-79.48,75.93-.9a355,355,0,0,0,40.91-36.86,355.46,355.46,0,0,0,48-63.53L1920.5,143.76V495.39H.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain2);
export default __webpack_public_path__ + "static/media/mountain2.2217926857b655aa55b487141609a216.svg";
export { ForwardRef as ReactComponent };